import React from "react";
import { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../../contexts/auth";
import { MdCancel, MdCheckCircle } from "react-icons/md";
import { translate } from "../../../utils/Common";
import "./index.css";
import Spinner from "../../../components/Spinner";

const Activate = (props) => {
  const userContext = useContext(AuthContext);
  const country = props.match.params.country;
  const token = props.match.params.token;
  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState("");
  const [codeResponse, setCodeResponse] = useState(false);

  useEffect(() => {
   
      const activateAccount = async () => {
        const result = await userContext.activateAccount(country, token);
        
        setTimeout(() => {
          setResponse(result.message);
          setCodeResponse(result.icon);
          setIsLoading(false);
        }, 2000);
      };
      setTimeout(() => activateAccount(), 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="login flex items-center justify-center"
      style={{
        backgroundImage: "url('/img/pattern-boxit2.png')",
        backgroundSize: "cover",
      }}
    >
      <div className="login-form shadow text-center">
        <div className="mb-3">
          <img src="/img/logo-boxit.png" alt="Boxit" height="40" />
          <hr />
          {isLoading ? (
            <Spinner type={1} size={50} />
          ) : (
            <>
              {codeResponse ? (
                <MdCheckCircle size={60} color="green" />
              ) : (
                <MdCancel size={60} color="red" />
              )}
              <h4>{translate("login.activate.title")}</h4>
              <p>{response}</p>
            </>
          )}
        </div>

        <Link to="/login">
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 btn-outline-blue btn-signup rounded-pill uppercase m-2"
            type="back"
          >
            {translate("global.goBack")}
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Activate;
